module.exports = __webpack_public_path__ + "img/DCA Bot_1.68a0cdda.svg";